import { yupResolver } from '@hookform/resolvers/yup'
import { Box, Grid, Button, MobileStepper } from '@mui/material'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import { FormInputPassword } from '../../components/forms/formInputs'
import { FormValidationCompleteRegisterStepOne } from '../../components/forms/formValidations'
import { acSetCompleteRegisterData } from '../../store/actions'

/**
 * @description Renders step one of the complete resgister stepper. Each step is a separate form.
 *
 * @author Maria Eduarda Franke
 * @param {Object} completeRegisterData - Stepper saved data
 * @param {function} handleNext - Function to handle next button click
 * @param {boolean} isMobile - Whether the user accessed via mobile device or not
 * @returns {JSX.Element} The rendered CompleteRegisterStepOneForm component.
 */
export const CompleteRegisterStepOneForm = ({ completeRegisterData, handleNext, isMobile }) => {

    const defaultValues = {
        password: completeRegisterData?.password || '',
        confirmPassword: ''
    }

    const dispatch = useDispatch()

    const { control, handleSubmit, formState: { errors } } = useForm({
        defaultValues: defaultValues,
        resolver: yupResolver(FormValidationCompleteRegisterStepOne)
    })

    const onSubmit = handleSubmit((data) => {
        dispatch(acSetCompleteRegisterData({
            password: data.password
        }))
        handleNext()
    })

    return (
        <Box component='form' onSubmit={onSubmit} noValidate>

            <FormInputPassword
                name='password'
                label='Senha'
                control={control}
                errors={errors.password}
                fullWidth
                margin='normal'
                required
            />

            <FormInputPassword
                name='confirmPassword'
                label='Confirmar Senha'
                control={control}
                errors={errors.confirmPassword}
                fullWidth
                margin='normal'
                required
            />

            <Grid container sx={{ mt: 2 }}
                display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'
            >
                <Grid item xs={4} display='flex' justifyContent='flex-start'>
                </Grid>

                <Grid item xs={4} display='flex' justifyContent='center'>
                    {
                        isMobile && (
                            <MobileStepper
                                variant='dots'
                                position='static'
                                steps={3}
                                activeStep={0}
                            />
                        )
                    }
                </Grid>

                <Grid item xs={4} display='flex' justifyContent='flex-end'>
                    <Button type='submit' variant='contained'>
                        Avançar
                    </Button>
                </Grid>
            </Grid>

        </Box>
    )

}

CompleteRegisterStepOneForm.propTypes = {
    completeRegisterData: PropTypes.object,
    handleNext: PropTypes.func.isRequired,
    isMobile: PropTypes.bool.isRequired
}
